import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const UbiEducationLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. Does a candidate need to create an account with UBI to apply for an education loan?",
            content: "Applicants don't need to have an account in the Union Bank of India. "
        },
        {
            title: "2. Is it possible for a student who has lost both parents to seek an education loan from the Union Bank of India?",
            content: "When both parents are no longer alive, it is possible to include a close relative or guardian as a co-applicant."
        },
        {
            title: "3. Is there a penalty imposed by the Union Bank of India for early repayment of loans?",
            content: "Individuals who have taken education loans from the Union Bank of India are not subjected to any prepayment penalty. After 6 months of receiving the loan, borrowers are free to repay the loan without incurring any additional fees."
        },
        {
            title: "4. What is the process for an applicant to calculate their EMI for an education loan from the Union Bank of India?",
            content: "The EMI calculator on Credere Finance's website offers a convenient way for applicants to determine the EMI for an education loan from Union Bank of India. By simply inputting the loan amount, loan tenure, and applicable interest rate into the calculator, individuals can quickly obtain the EMI amount. This online tool provides a simpler and more user-friendly alternative for calculating EMIs."
        }, {
            title: "5. In the Union Bank of India, under whose name is the education loan sanctioned?",
            content: "An education loan is granted by the Union Bank under the student's name."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"UBI Education Lending Partner"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"UBI Education Lending Partner"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">UBI Education Loan for Abroad Studies</h5>
                            <p className="loan-eligibility-des">The Union Bank of India (UBI) was founded in 1919 as a limited company and later nationalized in 1969. The bank offers a variety of financial and banking services, including corporate and personal banking, international banking, and education loans for study abroad and in India. After merging with Andhra Bank and Corporation Bank in 2020, Union Bank of India emerged to become the country's fifth-largest public sector bank.</p>
                            <p className="loan-eligibility-des">Union Bank of India provides a range of secured and unsecured loan options to its customers.</p>

                            <h5 className="about-head">Major Details about Union Bank of India's Education Loan Scheme</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">
                                        09.25%-09.75%
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Secured loan: upto INR 1.5 cr(This amount may vary depending on the Student's profile) Unsecured loan: INR 40 Lakh
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Processing Fees</td>
                                        <td>INR 5,000 (Refundable if disbursement within 3 months)</td>
                                    </tr>
                                    <tr>
                                        <td>Margin Money</td>
                                        <td>Secured Loan -10% (Listed /universities) Secured Loan -15%(non Listed universities)</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Moratorium period
                                        </td>

                                        <td className="">
                                            Course duration + 12 months</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Repayment tenure
                                        </td>
                                        <td className="">
                                            15 years
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <ol className="subhead-ul">
                                <li>The moratorium period provides a time frame where you are not required to repay your education loan.</li>
                                <li>Margin money is the amount of money that the borrower is needed to contribute towards the loan, while the remaining amount is paid by the lender.</li>
                            </ol>
                            <h5 className="about-head">Eligibility Criteria for UBI International Education Loan</h5>
                            <h5 className="about-head">Age</h5>
                            <p className="loan-elegibility-des">To apply, the candidate must hold Indian citizenship and be at least 18 years old at the time of applying.</p>
                            <h5 className="about-head">Education Qualification</h5>
                            <p className="loan-elegibility-des">The applicant must have been secured into a reputable university or institution for a program leading to the desired degree or diploma to be eligible for an education loan.</p>
                            <h5 className="about-head">Eligibility Criteria for UBI International Education Loan</h5>

                            <h5 className="about-head">Age</h5>
                            <p className="loan-elegibility-des">To apply, the candidate should be a citizen of India and must be 18 years old or above at the time of applying.</p>

                            <h5 className="about-head">Education Qualification</h5>
                            <p className="loan-elegibility-des">The applicant must have been secured into a reputable university or institution for a program leading to the desired degree or diploma to be eligible for an education loan.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">
                            
                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">To be considered, the applicant must maintain a consistently impressive academic record and satisfy the lending institution's minimum academic standards. Moreover, the student is required to complete any prerequisite tests such as GRE, IELTS, or TOEFL.</p>

                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">A parent or legal guardian with a steady source of income and a good credit history may be the co-applicant.</p>

                            <h5 className="about-head">Country of Study</h5>
                            <p className="loan-elegibility-des">Foreign institutes/universities in the UK, Canada, USA, Australia, Japan, Singapore, Hong Kong, New Zealand, and Europe (including Belgium, Austria, Denmark, France, Finland, Germany, Greece, Italy, Ireland, Netherlands, Switzerland, Sweden, United Kingdom) are covered under the scheme.</p>

                            <h5 className="about-head">Courses Covered</h5>
                            <p className="loan-elegibility-des">Regular graduate degrees, post-graduate degrees, diplomas, certificates, and doctoral courses, including bachelor's, master's, MCA, MBA, MS, and more, are eligible. UBI also provides financing for:</p>
                            <ul className="loan-elegibility-des">
                            <li>Courses conducted by CIMA-London and CPA in the USA</li>
                            <li>Pilot training, aeronautical, and shipping degree or diploma courses</li>
                            </ul>

                            <h5 className="about-head">Acceptable Collateral</h5>
                            <p className="loan-elegibility-des">Union Bank of India accepts the following as collateral:</p>
                            <ul className="loan-elegibility-des">
                            <li>Immovable property such as a house, flat, and open plots (must be legally sanctioned)</li>
                            <li>Fixed deposits</li>
                            </ul>

                            <h5 className="about-head">Documents Needed for UBI Loan for Overseas Education</h5>

                            <h5 className="about-head">Applicants' Documents</h5>
                            <ul className="loan-elegibility-des">
                            <li>Identity proof: PAN/ Driver’s License/ Passport/ Voter ID/ Government ID</li>
                            <li>Address proof: Recent utility bill, driving license, or UID card</li>
                            <li>Education loan application form</li>
                            <li>Passport</li>
                            <li>Past academic records: 10th, 12th mark sheets, undergraduate results (semester-wise)</li>
                            <li>Proof of admission (conditional letter accepted)</li>
                            <li>Entrance exam results (GMAT, GRE, TOEFL, etc.)</li>
                            <li>Statement of expenses</li>
                            <li>2 passport-size photographs</li>
                            <li>Student's bank account statement (if applicable)</li>
                            <li>Loan account statement (if applicable)</li>
                            </ul>

                            <h5 className="about-head">Co-applicants' Documents</h5>
                            <ul className="loan-elegibility-des">
                            <li>Address proof: Utility bill, passport, Aadhaar, or driving license</li>
                            <li>Identity proof: PAN/ Passport/ Driver’s license/ Voter ID/ Government ID</li>
                            <li>Loan A/C statement (if applicable)</li>
                            <li>2 passport-size photographs</li>
                            <li>Bank account statement (last 6 months)</li>
                            <li>Legal documents of collateral/property</li>
                            </ul>

                            <h5 className="about-head">Income Proof for Salaried Co-applicant/Guarantor</h5>
                            <ul className="loan-elegibility-des">
                            <li>Copy of Form 16 (last 2 years)</li>
                            <li>Salary slips (last 3 months)</li>
                            <li>Statement of assets & liabilities</li>
                            <li>Bank account statement (last 6 months – salary account)</li>
                            </ul>

                            <h5 className="about-head">Income Proof for Self-employed Co-applicant/Guarantor</h5>
                            <ul className="loan-elegibility-des">
                            <li>Last 2 years IT returns (if applicable)</li>
                            <li>Business address proof</li>
                            <li>Certificate of qualification (e.g., for CA, doctor)</li>
                            <li>TDS certificate (Form 16A, if applicable)</li>
                            <li>Bank account statement (last 6 months)</li>
                            <li>Statement of assets & liabilities</li>
                            </ul>

                            <h5 className="about-head">Collateral-based Documents</h5>
                            <p className="loan-elegibility-des">Required documents vary based on property type and location. Common documents include:</p>
                            <ul className="loan-elegibility-des">
                            <li>Approved plan/map of the property</li>
                            <li>Registered sale deed</li>
                            <li>Chain documents</li>
                            <li>Occupancy proof</li>
                            <li>Latest property tax receipt</li>
                            </ul>

                            <h5 className="about-head">How to Get in Touch with UBI</h5>

                            <h5 className="about-head">Email</h5>
                            <p className="loan-elegibility-des">Send an email to <a href="mailto:customercare@unionbankofindia.com">customercare@unionbankofindia.com</a> with your detailed profile. UBI will respond with the next steps.</p>

                            <h5 className="about-head">Online Application</h5>
                            <p className="loan-elegibility-des">Visit the UBI website and go to the "Contact Us" section to submit the application form online. The bank will review and respond accordingly.</p>

                            <h5 className="about-head">Branch Visit</h5>
                            <p className="loan-elegibility-des">Visit your nearest UBI branch to receive assistance with the loan application and process.</p>

                            <h5 className="about-head">Apply via Credere Finance</h5>
                            <p className="loan-elegibility-des">Credere Finance is an education financing platform that helps students get loans without the hassle of bank visits. A counselor will guide you through the process and recommend the best lenders.</p>

                            <h5 className="about-head">Why Choose Credere Finance</h5>
                            <ul className="loan-elegibility-des">
                            <li><strong>Short Waiting Period:</strong> Loan approval within 15–20 days (compared to 30–45 days when applying directly).</li>
                            <li><strong>Guaranteed Best Loan:</strong> If you find a better offer, Credere Finance will pay the interest difference.</li>
                            <li><strong>Free Services:</strong> No service charges or commissions.</li>
                            <li><strong>Lender Comparison:</strong> Expert advisors compare lenders on interest rates, tenure, fees, etc.</li>
                            <li><strong>Higher Approval Chances:</strong> They assist with documentation and resolve issues quickly by coordinating with UBI.</li>
                            </ul>

                            <h5 className="about-head">How to Apply via Credere Finance </h5>
                            <p className="loan-elegibility-des">You can apply online directly through the UBI website or, for a smoother experience, choose Credere Finance. They allow you to complete the entire process digitally and with expert guidance.</p>

                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default UbiEducationLendingPartner;